
import React from "react";
import ProjectWrapper from '../../components/ProjectWrapper';

export default (props) => {

  return (
    <ProjectWrapper {...props}></ProjectWrapper>
  );
}